

import React, { useState, useEffect } from "react";
import { exportTableToPDF } from "../utils/exportPDF";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";


const PurchaseExpenditure = () => {
  const navigate = useNavigate();
  const [expenditures, setExpenditures] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user_id, setUserId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // 🔹 Search filter states
  const [itemName, setItemName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [getSelectedMenu, setSelectedMenu] = useState(
    localStorage.getItem("selectedMenu") || ""
  );

  // 🔹 Edit Modal states
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [stocks, setStocks] = useState([]);
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportStartDate, setExportStartDate] = useState("");
  const [exportEndDate, setExportEndDate] = useState("");

  useEffect(() => {
    localStorage.setItem("selectedMenu", getSelectedMenu);
  }, [getSelectedMenu]);

  useEffect(() => {
    const storedUserId = localStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!user_id) return;
    const fetchExpenditures = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `https://ims-backend.indevconsultancy.in/admin-panel/expenditures/?user_id=${user_id}`
        );
        setExpenditures(res.data);
        setFilteredData(res.data);
      } catch (error) {
        console.error("Error fetching expenditures:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchExpenditures();
  }, [user_id]);

  // 🔹 Fetch Stocks
  useEffect(() => {
    const fetchStocks = async () => {
      try {
        const res = await axios.get(
          `https://ims-backend.indevconsultancy.in/admin-panel/main-stock/?user_id=${user_id}`
        );
        setStocks(res.data); // 👈 Stocks API ka data
      } catch (error) {
        console.error("Error fetching stocks:", error);
      }
    };

    if (user_id) {
      fetchStocks();
    }
  }, [user_id]);

  // ✅ Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  // ✅ Normalize date (YYYY-MM-DD)
  const normalizeDate = (date) => {
    if (!date) return "";
    return new Date(date).toISOString().split("T")[0];
  };

  // ✅ Apply filters
  const handleSearch = (e) => {
    e.preventDefault();
    const filtered = expenditures.filter((item) => {
      const itemMatch = itemName
        ? item.stock_name.toLowerCase().includes(itemName.toLowerCase())
        : true;

      const itemDate = normalizeDate(item.date);
      const startMatch = startDate ? itemDate >= startDate : true;
      const endMatch = endDate ? itemDate <= endDate : true;

      return itemMatch && startMatch && endMatch;
    });
    setFilteredData(filtered);
  };

  const handleReset = () => {
    setItemName("");
    setStartDate("");
    setEndDate("");
    setFilteredData(expenditures);
  };

  // Delete function
  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        `https://ims-backend.indevconsultancy.in/admin-panel/expenditures/${id}/delete/`
      );
      alert(response.data.message || "Deleted successfully!");
      setFilteredData((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };


  const handleEdit = (item) => {
    const stock = stocks.find((s) => s.stock_name === item.stock_name);

    setEditItem({
      ...item,
      date: normalizeDate(item.date),
      items_id: stock ? stock.items_id : item.items_id,
      stock_name: stock ? stock.stock_name : item.stock_name,
      unit_price: stock ? stock.unit : item.unit_price,
      availableQty: stock ? stock.quantity : 0,
      quantity: parseFloat(item.quantity) || 0,
      total: parseFloat(item.total) || 0,
    });

    setShowModal(true);
  };

  const handleUpdate = async () => {
    if (editItem.quantity > (editItem.availableQty || 0)) {
      alert("Quantity cannot be greater than available stock!");
      return;
    }

    try {
      const payload = {
        user_id: editItem.user_id,
        items_id: editItem.items_id,
        stock_name: editItem.stock_name,
        quantity: String(editItem.quantity || "0"),
        unit_price: String(editItem.unit_price || "0"),
        total: String(editItem.total || "0"),
        date: editItem.date || "",
      };

      await axios.put(
        `https://ims-backend.indevconsultancy.in/admin-panel/expenditures/${editItem.id}/update/`,
        payload
      );

      alert("Updated successfully!");

      setFilteredData((prev) =>
        prev.map((i) => (i.id === editItem.id ? { ...i, ...payload } : i))
      );

      setShowModal(false);
    } catch (error) {
      console.error("Update failed:", error);
      alert(error.response?.data?.error || "Update failed. Check console for details.");
    }
  };
  const handleExportExcel = async () => {
    if (filteredData.length === 0) {
      alert("No data to export. Please apply filters and search first.");
      return;
    }

    setLoading(true);
    try {
      // Prepare Excel data from filteredData
      const headers = ["S.No", "Stock Name", "Available Qty", "Quantity", "Price", "Total", "Expenditure Date"];
      const rows = [];

      for (let i = 0; i < filteredData.length; i++) {
        const exp = filteredData[i];
        
        // Get stock details for available qty and price
        const stock = stocks.find((s) => s.stock_name === exp.stock_name);
        const availableQty = stock ? stock.quantity : "0";
        const price = stock ? stock.unit : exp.unit_price;

        rows.push([
          i + 1,
          exp.stock_name,
          availableQty,
          exp.quantity,
          price,
          exp.total,
          formatDate(exp.date)
        ]);
      }

      // Convert to CSV format
      const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");

      // Create downloadable file
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      
      // Dynamic filename based on filters
      let fileName = "expenditure_report";
      if (itemName) fileName += `_${itemName}`;
      if (startDate && endDate) fileName += `_${startDate}_to_${endDate}`;
      
      link.download = `${fileName}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      alert("Export completed successfully!");
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Export failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  // const handleExportCSV = async () => {
  //   setLoading(true);
  //   try {
  //     const params = {
  //       user_id,
  //       from_date: startDate || "",
  //       to_date: endDate || "",
  //       item_name: itemName || "",
  //     };

  //     // remove empty values
  //     Object.keys(params).forEach(
  //       (key) =>
  //         (params[key] === "" || params[key] === null) && delete params[key]
  //     );

  //     // ✅ Fetch JSON data
  //     const response = await axios.get(
  //       `https://ims-backend.indevconsultancy.in/admin-panel/expenditures/`,
  //       { params }
  //     );

  //     const data = Array.isArray(response.data)
  //       ? response.data
  //       : response.data?.data || [];

  //     if (!data.length) {
  //       alert("No records found to export.");
  //       return;
  //     }

  //     // ✅ Pick only needed fields
  //     const headers = ["Item", "Quantity", "Price", "Total", "Date"];
  //     const rows = data.map((row) => [
  //       row.stock_name,
  //       row.quantity,
  //       row.unit_price,
  //       row.total,
  //       row.date,
  //     ]);

  //     // ✅ Convert to CSV format
  //     const csvContent =
  //       [headers, ...rows].map((e) => e.join(",")).join("\n");

  //     // ✅ Create a downloadable file
  //     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //     const link = document.createElement("a");
  //     const url = URL.createObjectURL(blob);
  //     link.href = url;

  //     // ✅ Dynamic filename
  //     let fileName = "purchase_items";
  //     if (itemName) fileName += `_item-${itemName}`;
  //     if (startDate && endDate) fileName += `_from-${startDate}_to-${endDate}`;

  //     link.download = `${fileName}.csv`;

  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error("Error exporting data:", error.response || error.message || error);
  //     alert("Export failed, please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleExportCSV = async () => {
    setLoading(true);
    try {
      const params = {
        user_id,
        from_date: startDate || "",
        to_date: endDate || "",
        item_name: itemName || "",
      };

      // remove empty values
      Object.keys(params).forEach(
        (key) =>
          (params[key] === "" || params[key] === null) && delete params[key]
      );

      // Fetch JSON data
      const response = await axios.get(
        `https://api-ims.indevconsultancy.in/report.php`,
        { params }
      );

      const data = Array.isArray(response.data.data)
        ? response.data.data
        : [];

      if (!data.length) {
        alert("Please Select Start Date and End Date");
        return;
      }

      // Pick only needed fields
      const headers = ["Sl", "Gld", "Item", "Opening", "Purchased/IN", "Consumed/Out", "Balance"];
      const rows = data.map((row) => [
        row.id,
        row.items_id,
        row.stock_name,
        row.opening,
        row.purchase_quantity,
        row.consume_out,
        row.available_quantity,
      ]);

      // Convert to CSV format
      const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");

      // Create downloadable file
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;

      // Dynamic filename
      let fileName = "purchase_items";
      if (itemName) fileName += `_item-${itemName}`;
      if (startDate && endDate) fileName += `_from-${startDate}_to-${endDate}`;

      link.download = `${fileName}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting data:", error.response || error.message || error);
      alert("Export failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleExportPDF = async () => {
    setLoading(true);
    try {
      const params = {
        user_id,
        from_date: startDate || "",
        to_date: endDate || "",
        item_name: itemName || "",
      };

      // remove empty values
      Object.keys(params).forEach(
        (key) =>
          (params[key] === "" || params[key] === null) && delete params[key]
      );

      // ✅ Fetch JSON data
      const response = await axios.get(
        `https://api-ims.indevconsultancy.in/report.php`,
        { params }
      );

      const data = Array.isArray(response.data.data)
        ? response.data.data
        : [];

      if (!data.length) {
        alert("Please Select Start Date and End Date");
        return;
      }

      // ✅ Build an HTML table dynamically
      const headers = ["Sl", "Gld", "Item", "Opening", "Purchased/IN", "Consumed/Out", "Balance"];
      const rows = data.map(
        (row) => `
        <tr>
          <td>${row.id}</td>
          <td>${row.items_id}</td>
          <td>${row.stock_name}</td>
          <td>${row.opening}</td>
          <td>${row.purchase_quantity}</td>
          <td>${row.consume_out}</td>
          <td>${row.available_quantity}</td>
        </tr>`
      );

      const htmlContent = `
      <div style="padding:20px;font-family:Arial;">
        <h2 style="text-align:center;color:#004999;">Purchase Report</h2>
        ${startDate && endDate
          ? `<p style="text-align:center;">From: ${startDate} To: ${endDate}</p>`
          : ""
        }
        <table style="width:100%;border-collapse:collapse;font-size:12px;">
          <thead>
            <tr style="background:#004999;color:#fff;">
              ${headers.map((h) => `<th style="border:1px solid #d8e2ef;padding:6px;">${h}</th>`).join("")}
            </tr>
          </thead>
          <tbody>
            ${rows.join("")}
          </tbody>
        </table>
      </div>
    `;

      // ✅ Convert HTML → Canvas → PDF
      const container = document.createElement("div");
      container.innerHTML = htmlContent;
      document.body.appendChild(container);

      const canvas = await html2canvas(container, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);

      // ✅ Dynamic filename
      let fileName = "purchase_items";
      if (itemName) fileName += `_item-${itemName}`;
      if (startDate && endDate) fileName += `_from-${startDate}_to-${endDate}`;

      pdf.save(`${fileName}.pdf`);

      document.body.removeChild(container);
    } catch (error) {
      console.error("Error exporting PDF:", error.response || error.message || error);
      alert("PDF export failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading vendors...</p>;
  return (
    <div className="container-fluid px-2">
      {/* Header */}
      <div className="row align-items-center justify-content-between py-2">
        <div className="col-md-6 col-6">
          <span className="fs-1">Expenditure List</span>
        </div>
        <div className="col-md-6 col-6 text-end">
          <div className="bg-light p-2 rounded d-inline-flex align-items-center justify-content-end">
            <span className="me-1">Expenditure List</span>
            <span className="mx-1">/</span>
            <Link to="/purchaseDashboard">Home</Link>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header border-info">
          <form onSubmit={handleSearch}>
            <div className="row g-3">
              <div className="col-lg">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Items Name"
                  value={itemName}
                  onChange={(e) => setItemName(e.target.value)}
                />
              </div>
              <div className="col-lg">
                <input
                  type="date"
                  className="form-control"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="col-lg">
                <input
                  type="date"
                  className="form-control"
                  placeholder="End Date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>


              <div className="col-lg-2">
                <button type="submit" className="btn btn-primary w-100">
                  Search
                </button>
              </div>
              <div className="col-lg-1">
                <button
                  type="button"
                  className="btn btn-outline-dark w-100"
                  onClick={handleReset}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="card-body">
          <div className="d-flex justify-content-between mb-2">
            <h6 className="fw-bold mb-0">
              Total Item(s): <span>{filteredData.length}</span>
            </h6>
            <div>
            {getSelectedMenu === "report" ? (
              <div>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-primary btn-sm mb-1"
                    onClick={handleExportCSV}
                    disabled={loading}
                  >
                    <i className="fas fa-file me-1"></i> Export CSV
                  </button>

                  <button
                    className="btn btn-primary btn-sm mb-1"
                    onClick={handleExportPDF}
                    disabled={loading}
                  >
                    <i className="fas fa-file me-1"></i> Export PDF
                  </button>
                </div>
              </div>
            ) : (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-primary btn-sm mb-1"
                  onClick={handleExportExcel}
                  disabled={loading}
                >
                  <i className="fas fa-file-excel me-1"></i> Export CSV
                </button>
                <button
                  className="btn btn-primary btn-sm mb-1"
                  onClick={() => navigate("/addExpenditure")}
                >
                  <i className="fas fa-plus" title="Add"></i> Add
                </button>
              </div>
            )}
            </div>
          </div>

          <div className="table-responsive scrollbar">
            <table className="table text-center table-bordered table-striped fs--1 mb-0">
              <thead className="bg-primary text-white">
                <tr>
                  <th>S.No.</th>
                  <th>Stock Name</th>
                  <th>Quantity</th>
                  <th>Total</th>
                  <th>Expenditure Date</th>
                  {getSelectedMenu !== "report" && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6">Loading...</td>
                  </tr>
                ) : filteredData.length > 0 ? (
                  currentItems.map((exp, index) => (
                    <tr key={exp.id}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{exp.stock_name}</td>
                      <td>{exp.quantity}</td>
                      <td>{exp.total}</td>
                      <td>{formatDate(exp.date)}</td>
                      {getSelectedMenu !== "report" && (
                        <td>
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-primary btn-sm"
                              title="View"
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            <button
                              className="btn btn-warning btn-sm"
                              title="Edit"
                              onClick={() => handleEdit(exp)}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                            <button
                              className="btn btn-danger btn-sm"
                              title="Delete"
                              onClick={() => handleDelete(exp.id)}
                            >
                              <i className="fas fa-trash"></i>
                            </button>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">No data found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {showModal && (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Edit Expenditure</h5>
                    <button
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    {/* Stock Name (readonly dropdown or input) */}
                    <input
                      type="text"
                      className="form-control mb-2"
                      value={editItem.stock_name}
                      readOnly
                    />

                    {/* Available Qty (readonly) */}
                    <input
                      type="number"
                      className="form-control mb-2"
                      value={editItem.availableQty || ""}
                      readOnly
                    />

                    {/* Quantity (editable, with validation) */}
                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Quantity"
                      value={editItem.quantity}
                      onChange={(e) => {
                        const qty = parseFloat(e.target.value) || 0;
                        if (qty > (editItem.availableQty || 0)) {
                          alert(
                            "Quantity cannot be greater than available stock!"
                          );
                          return;
                        }
                        setEditItem({
                          ...editItem,
                          quantity: qty,
                          total: qty * (editItem.unit_price || 0), // 🔹 auto calc
                        });
                      }}
                    />

                    {/* Price (readonly) */}
                    <input
                      type="number"
                      className="form-control mb-2"
                      value={editItem.unit_price || ""}
                      readOnly
                    />

                    {/* Total (auto calc) */}
                    <input
                      type="number"
                      className="form-control mb-2"
                      value={editItem.total || ""}
                      readOnly
                    />

                    {/* Date */}
                    <input
                      type="date"
                      className="form-control mb-2"
                      value={editItem.date || ""}
                      onChange={(e) =>
                        setEditItem({ ...editItem, date: e.target.value })
                      }
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button className="btn btn-primary" onClick={handleUpdate}>
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Export Modal */}
          {showExportModal && (
            <div
              className="modal fade show"
              style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Export Expenditure Report</h5>
                    <button
                      className="btn-close"
                      onClick={() => {
                        setShowExportModal(false);
                        setExportStartDate("");
                        setExportEndDate("");
                      }}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={exportStartDate}
                        onChange={(e) => setExportStartDate(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={exportEndDate}
                        onChange={(e) => setExportEndDate(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => {
                        setShowExportModal(false);
                        setExportStartDate("");
                        setExportEndDate("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={handleExportExcel}
                      disabled={loading}
                    >
                      {loading ? "Downloading..." : "Download"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <span>
              Page {currentPage} of {totalPages}
            </span>

            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseExpenditure;
